function createStyle(doc, cssText) {
  let style = doc.createElement("style");
  style.type = "text/css";
  style.appendChild(window.document.createTextNode(cssText));
  return style;
}

function createIFrame(parent) {
  if (parent === void 0) {
    parent = window.document.body;
  }
  let el = window.document.createElement("iframe");
  let css =
    "visibility:hidden;width:0;height:0;position:absolute;z-index:-9999;bottom:0;";
  el.setAttribute("src", "about:blank");
  el.setAttribute("style", css);
  el.setAttribute("name", "printFrame");
  el.setAttribute("id", "printFrame");
  el.setAttribute("width", "0");
  el.setAttribute("height", "0");
  el.setAttribute("wmode", "opaque");
  parent.appendChild(el);
  return el;
}

function print(el, cssText, disable, callback) {
  if (disable) return; //disable print for hakimi ,safi
  let _a = createIFrame();
  let contentDocument = _a.contentDocument;
  let contentWindow = _a.contentWindow;
  if (!contentDocument || !contentWindow) {
    console.log("error is hereeee");
  }
  if (cssText) {
    contentDocument.head.appendChild(createStyle(contentDocument, cssText));
  }

  let elCopy = el.cloneNode(true);
  if (elCopy) {
    contentDocument.body.innerHTML = "";
    contentDocument.body.appendChild(elCopy);

    if (callback) {
      callback({
        window: contentWindow,
        document: contentDocument,
        element: elCopy,
        launchPrint: function() {
          return launchPrint(contentWindow);
        },
      });
    } else {
      launchPrint(contentWindow);
    }
  }
}

function launchPrint(contentWindow) {
  // let result = contentWindow.document.execCommand("print", false, null);
  // if (!result) {
  // }
  // let is_chrome = Boolean(contentWindow.chrome);
  setTimeout(function() {
    // wait until all resources loaded
    contentWindow.document.body.focus();
    contentWindow.print();
  }, 1000);
  // if (is_chrome) {
  //   setTimeout(function() {
  //     // wait until all resources loaded
  //     contentWindow.document.body.focus();
  //     contentWindow.print();
  //   }, 700);
  // } else {
  //   contentWindow.document.body.focus();
  //   contentWindow.print();
  // }
  // window.frames["printFrame"].print();
  // let frm = contentWindow.print();
  // frm.focus();
  // frm.print();
  // document.getElementById("iframe_id").contentWindow.print();
  // contentWindow.print();
}

export default print;
